import React, { useState, useEffect } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { useDispatch } from "react-redux";
import { updateService } from "../../../redux/Actions/Service/serviceAction";
import TextInputModal from "../../common/TextInputModal";

export default function ServiceDataEditInput({
  id,
  label,
  value_name,
  value = "",
}) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value);
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    if (value !== inputValue) setInputValue(value);
  }, [edit]);

  const onSubmit = async () => {
    if (value.toString().trim() == inputValue.toString().trim()) {
      return setEdit(false);
    } else {
      const params = {
        [value_name]: inputValue,
      };

      await dispatch(updateService({ ...params, id }));
      return setEdit(false);
    }
  };
  if (edit) {
    return (
      <li className="d-flex justify-content-between align-items-center">
        <TextInputModal
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <div className="d-flex align-items-center ml-3">
          <FaCheck
            className="text-success cursor-pointer"
            size={18}
            onClick={() => onSubmit()}
          />
          <FaTimes
            className="text-danger cursor-pointer"
            style={{
              marginLeft: "10px",
            }}
            size={18}
            onClick={() => setEdit(false)}
          />
        </div>
      </li>
    );
  }
  return (
    <li
      className={`d-flex justify-content-between align-items-center`}
      style={{ fontSize: "0.8rem" }}
    >
      <span>
        <span className="font-weight-bold">{label}: </span>
        {value}
      </span>
      <div className="d-flex align-items-center ml-3">
        <MdEdit
          className="cursor-pointer"
          color="green"
          onClick={() => setEdit(true)}
        />
      </div>
    </li>
  );
}
